import { get } from "@ember/object"
import type {
  Card,
  CardCourseSlot,
  CardGoogleClassroom,
  CardStandards,
  CardTitleValueHtml,
  CardValueHtml,
} from "@shared/models/card-stack"
import * as R from "remeda"

export function isCardGoogleClassroom(card: Card): card is CardGoogleClassroom {
  return (card as CardGoogleClassroom).type === "card-google-classroom"
}
export function isCardTitleValueHtml(card: Card): card is CardTitleValueHtml {
  return (card as CardTitleValueHtml).type === "card-title-value-html"
}
export function isCardValueHtml(card: Card): card is CardValueHtml {
  return (card as CardValueHtml).type === "card-value-html"
}
export function isCardStandards(card: Card): card is CardStandards {
  return (card as CardStandards).type === "card-standards"
}

export function isCardCourseSlot(card: Card): card is CardCourseSlot {
  return (card as CardCourseSlot).type === "card-course-slot"
}

export function filterGoogleClassroomCards(cards: Array<Card>) {
  return R.filter(cards, isCardGoogleClassroom)
}

export function findGoogleClassroomCard(cards: Array<Card>, id: string) {
  return R.pipe(
    cards,
    R.filter(isCardGoogleClassroom),
    R.find((card) => get(card, "id") === id)
  )
}
